import { getProductTypeLabels } from './getProductTypeLabels';
import React from 'react';
import T from 'prop-types';
import { get, isEmpty } from 'lodash-es';
import { Heading, Paragraph } from '@piggybank/core';
import { Hint } from '@piggybank/form';
import { Translation, Optional } from 'srcAlias/client/locale';
import {
  STRUCTURED_PRODUCTS_ACCOUNT,
  EQUITY_INVESTMENT_ACCOUNT,
} from 'srcAlias/client/enums/productDescriptionCode';
import { CREATED } from 'srcAlias/client/enums/accountCreationStatus';

const AcceptPageInfoSection = ({
  productType,
  productID,
  applicationDecisionData,
}) => {
  const showContent = () => {
    const accountDetails = applicationDecisionData.investmentAccounts;
    const structuredProductScenario =
      STRUCTURED_PRODUCTS_ACCOUNT &&
      accountDetails.filter(
        (product) => product.productCode === STRUCTURED_PRODUCTS_ACCOUNT
      ) &&
      accountDetails.filter(
        (product) =>
          product.productCode === EQUITY_INVESTMENT_ACCOUNT &&
          product.openAccountStatus === CREATED
      );
    const equitiesScenario =
      EQUITY_INVESTMENT_ACCOUNT &&
      !isEmpty(
        accountDetails.filter(
          (product) =>
            product.productCode === EQUITY_INVESTMENT_ACCOUNT &&
            product.openAccountStatus === CREATED
        )
      ) &&
      accountDetails.length === 1;
    return !isEmpty(structuredProductScenario) || equitiesScenario;
  };

  return (
    <>
      <Heading level={2} accentBar>
        <Translation path="brandBarHeading" />
      </Heading>
      <Paragraph>
        <Translation
          path={get(
            getProductTypeLabels,
            `${productType}_${productID}.labelText`,
            ''
          )}
        />
      </Paragraph>
      <Optional>
        <Hint>
          <Translation path="utNote" />
        </Hint>
      </Optional>

      {get(
        getProductTypeLabels,
        `${productType}_${productID}.informationText`,
        ''
      ) &&
        showContent() && (
          <Paragraph>
            <Translation
              path={get(
                getProductTypeLabels,
                `${productType}_${productID}.informationText`,
                ''
              )}
            />
          </Paragraph>
        )}
      <Heading level={3}>
        {get(
          getProductTypeLabels,
          `${productType}_${productID}.headingHelpText`,
          ''
        ) && (
          <Translation
            path={get(
              getProductTypeLabels,
              `${productType}_${productID}.headingHelpText`,
              ''
            )}
          />
        )}
      </Heading>
      <Paragraph>
        {get(
          getProductTypeLabels,
          `${productType}_${productID}.helpText`,
          ''
        ) && (
          <Translation
            path={get(
              getProductTypeLabels,
              `${productType}_${productID}.helpText`,
              ''
            )}
          />
        )}
      </Paragraph>

      <Paragraph>
        {get(
          getProductTypeLabels,
          `${productType}_${productID}.helpText2`,
          ''
        ) && (
          <Translation
            path={get(
              getProductTypeLabels,
              `${productType}_${productID}.helpText2`,
              ''
            )}
          />
        )}
      </Paragraph>
    </>
  );
};

AcceptPageInfoSection.propTypes = {
  productID: T.string,
  productType: T.string,
  applicationDecisionData: T.object,
};

export default AcceptPageInfoSection;
